// Mock data for "Duplica tus Ventas" landing page clone
// NOTE: All data here is mocked for the frontend-only version.

export const brand = {
  name: "Duplica tus Ventas",
  tagline: "Consultoría especializada en spas y clínicas de belleza",
};

export const hero = {
  badge: "Consultoría especializada en spas y clínicas de belleza",
  titleLine1: "Duplica las ventas",
  titlePlain: "de tu ",
  titleAccent: "spa o clínica",
  titleLine3: "en 60 días",
  subtitle:
    "Ayudamos a dueños de spas y clínicas de belleza a escalar sus ingresos con estrategias probadas de marketing y ventas. Sin humo, con resultados.",
  cta: "Quiero mi diagnóstico gratuito",
};

export const painPoints = {
  eyebrow: "¿Te suena familiar?",
  headingBefore: "Si al menos ",
  headingAccent: "3 de estas",
  headingAfter: " son tu día a día, necesitamos hablar.",
  items: [
    "Tienes días con pocas citas en tu agenda",
    "Las ventas de tu negocio no crecen constantemente",
    "Tienes clientes que pagan una sesión y no regresan",
    "Pocos clientes te compran paquetes",
    "Trabajas mucho y aún así no ganas lo que quieres",
    "Tu equipo sabe brindar los servicios pero no sabe vender",
  ],
};

export const benefits = {
  eyebrow: "Qué obtienes",
  heading: "Un plan para crecer, no para sobrevivir.",
  items: [
    {
      icon: "TrendingUp",
      title: "Duplica tu facturación",
      desc: "Sistemas probados de venta y agendamiento que llevan tu spa o clínica al siguiente nivel en 60 días.",
    },
    {
      icon: "Heart",
      title: "Fideliza a tus clientas",
      desc: "Estrategias de retención y experiencia premium que convierten cada visita en una relación de largo plazo.",
    },
    {
      icon: "Megaphone",
      title: "Marketing que sí convierte",
      desc: "Embudos y contenido diseñado específicamente para el sector belleza y estética.",
    },
    {
      icon: "BarChart3",
      title: "Métricas claras",
      desc: "Deja de adivinar. Tablero de indicadores para tomar decisiones con datos reales de tu negocio.",
    },
  ],
  stats: [
    { value: "0", label: "Inversión en publicidad" },
    { value: "2x", label: "Crecimiento en ventas" },
    { value: "60 días", label: "Para duplicar tus ventas" },
  ],
};

export const process = {
  eyebrow: "Cómo trabajamos",
  heading: "Tres pasos para transformar tu negocio.",
  steps: [
    {
      num: "01",
      title: "Diagnóstico gratuito",
      desc: "Analizamos tu negocio, tus números y tu operación para encontrar los cuellos de botella.",
    },
    {
      num: "02",
      title: "Plan a la medida",
      desc: "Diseñamos una hoja de ruta específica para tu spa o clínica, con objetivos claros y accionables.",
    },
    {
      num: "03",
      title: "Implementación asistida",
      desc: "Te acompañamos paso a paso hasta que veas tus ventas duplicarse. Nada de teoría, todo ejecución.",
    },
  ],
};

export const testimonials = [
  {
    eyebrow: "Testimonio",
    heading: "Consiguió 19 clientes nuevos el primer mes",
    desc: "En un mes consiguió 19 clientes nuevos y vendió 7 paquetes de servicios.",
    quote:
      "Estoy feliz porque la inversión que hice me generó ganancias desde el inicio.",
    author: "Azul Hernández",
    videoId: "zEPQpp21Hw0",
    duration: "1 min",
  },
  {
    eyebrow: "Testimonio",
    heading: "Aumentó un 30% la retención de clientes",
    desc: "Antes no lograba que sus clientes regresaran, cada mes empezaba de cero.",
    quote:
      "Pensé que iba a ser complicado lograr resultados. Pero con la asesoría de Marco logré que regresara más del 30% de clientes nuevos.",
    author: "Sarah Pacheco",
    videoId: "pG1Ha8gCIq4",
    duration: "1 min",
  },
];

export const contact = {
  eyebrow: "Diagnóstico gratuito",
  heading: "Empecemos a duplicar tus ventas.",
  desc:
    "Déjanos tus datos y un asesor te contactará por WhatsApp en las próximas 24 horas para agendar tu sesión gratuita de diagnóstico. Sin compromiso.",
  bullets: [
    "Sesión 1 a 1 con un consultor especialista",
    "Análisis de tu situación actual",
    "Plan de acción para los próximos 60 días",
  ],
  fields: {
    name: "Nombre completo",
    phone: "Teléfono (WhatsApp)",
    business: "Nombre de tu negocio",
  },
  submit: "Quiero mi diagnóstico gratuito",
  disclaimer:
    "Al enviar aceptas ser contactado por WhatsApp. Tus datos están protegidos.",
};
